const initialState = {
    timeline: [],
    count: 0,
    isReadingTimeline: false,
    token: null,
    accountTimelineContacts: [],
    isReadingAccountTimelineContacts: false,
};

export default initialState;
